import React, { useState } from 'react';

interface LessonPlanModalProps {
  isOpen: boolean;
  onClose: () => void;
  googleDocUrl?: string;
}

const LessonPlanModal: React.FC<LessonPlanModalProps> = ({ 
  isOpen, 
  onClose, 
  googleDocUrl 
}) => {
  const [iframeLoading, setIframeLoading] = useState(true);
  const [iframeError, setIframeError] = useState(false);

  if (!isOpen) return null;

  // Default sample lesson plan if none provided
  const defaultDocUrl = "https://docs.google.com/document/d/e/2PACX-1vT57hPZRhxQtSzFrz6VyX0I7tr9Y7UCDtjP5emznptJvUEINEtF5icJ0WZ14n-pEibAThwGTBZApaVs/pub?embedded=true";
  const docUrl = googleDocUrl || defaultDocUrl;

  const handleIframeLoad = () => {
    setIframeLoading(false);
    setIframeError(false);
  };

  const handleIframeError = () => {
    setIframeLoading(false);
    setIframeError(true);
  };

  const openExternalDoc = () => {
    const externalUrl = docUrl.replace('?embedded=true', '');
    window.open(externalUrl, '_blank');
  };

  return (
    <div className="lesson-plan-modal-overlay" onClick={onClose}>
      <div className="lesson-plan-modal" onClick={e => e.stopPropagation()}>
        <div className="lesson-plan-header">
          <h2>Sample Lesson Plan</h2>
          <div className="lesson-plan-controls">
            <button className="open-external-btn" onClick={openExternalDoc}>
              🔗 Open in New Tab
            </button>
            <button className="close-modal-btn" onClick={onClose}>&times;</button>
          </div>
        </div>

        <div className="lesson-plan-content">
          {iframeLoading && (
            <div className="iframe-loading">
              <div className="loading-spinner"></div>
              <p>Loading lesson plan...</p>
            </div>
          )}

          {iframeError && (
            <div className="iframe-fallback">
              <h3>Unable to load lesson plan</h3>
              <p>The lesson plan couldn't be displayed in this window.</p>
              <button className="fallback-link" onClick={openExternalDoc}>
                Open Lesson Plan in New Tab
              </button>
            </div>
          )}

          <div className="iframe-container" style={{ display: iframeLoading || iframeError ? 'none' : 'block' }}>
            <iframe
              src={docUrl}
              onLoad={handleIframeLoad}
              onError={handleIframeError}
              title="Sample Lesson Plan"
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
                borderRadius: '0 0 30px 30px'
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LessonPlanModal; 